import React, { useEffect } from "react";
import Customaibanner from "./Customaibanner";
import Customaisolution from "./Customaisolution";
import Customaifeatures from "./Customaifeatures";
import Customaicards from "./Customaicards";
import Webbanner from "./Webbanner";

const Customai = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Customaibanner/>
      
      <Customaisolution/>

      <Customaifeatures/>
      <Customaicards/>
    </div>
  );
};

export default Customai;
